import React from "react";

/* Vertical spacing block — replaces legacy uiComponents Spacer. */
export function Spacer({ height = 0, style, ...rest }) {
  return (
    <div
      aria-hidden="true"
      style={{ width: "100%", marginBottom: height, ...style }}
      {...rest}
    />
  );
}

export default Spacer;
